import enUS from 'antd/locale/en_US';
import type { CustomLocale } from '../types/antd';

const custom: CustomLocale = {
  CopyButton: {
    label: 'Copy',
    successText: 'Copied.',
    failedText: 'Copy failed.',
  },
  ToggleButton: {
    activeText: 'Active',
    inactiveText: 'Inactive',
  },
};

export default {
  ...enUS,
  custom,
};
